import { dataExpand } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExpand = /*#__PURE__*/createIcon(dataExpand)
export default IconExpand
